let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hHwia")).then(() => parcelRequire('chF8B'));